import type { Map } from 'mapbox-gl';

import boundaryFillImage from 'components/MapBox/assets/boundaryFill.svg';
import noEntryFillImage from 'components/MapBox/assets/noEntryFill.svg';

import {
    BOUNDARY_FILL_IMAGE,
    BOUNDARY_FILL_IMAGE_PIXEL_RATIO,
    NO_ENTRY_FILL_IMAGE,
    NO_ENTRY_FILL_IMAGE_PIXEL_RATIO
} from './constants';

const useImages = () => {
    const loadImages = (map: Map) => {
        const boundaryFillImg = new Image(48, 48);

        boundaryFillImg.onload = () => {
            map.addImage(BOUNDARY_FILL_IMAGE, boundaryFillImg, {
                content: [0, 0, 48, 48],
                pixelRatio: BOUNDARY_FILL_IMAGE_PIXEL_RATIO
            });
        };
        boundaryFillImg.src = boundaryFillImage;

        const noEntryFillImg = new Image(80, 80);

        noEntryFillImg.onload = () => {
            map.addImage(NO_ENTRY_FILL_IMAGE, noEntryFillImg, {
                content: [0, 0, 80, 80],
                pixelRatio: NO_ENTRY_FILL_IMAGE_PIXEL_RATIO
            });
        };
        noEntryFillImg.src = noEntryFillImage;
    };

    return {
        loadImages
    };
};

export default useImages;
